const initialState = {
    isModalVisible: false,
  };
  
  const dataRequestModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_DATA_REQUEST_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_DATA_REQUEST_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default dataRequestModalReducer;
  